module.exports = __webpack_public_path__ + "img/2024_VolunteerShirt.fe4eecd4.jpg";